export default __webpack_public_path__ + "static/media/Comfortaa.42599e57.ttf";